import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AppCommonsModule } from '../../../../commons/app-commons.module';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { PlessSharedModule } from '../../../../shared/pless-shared.module';
import { KYMW1300TargetListComponent } from './kymw1300-target-list.component';
import { KYMW1300Model } from '../kymw1300.model';
import { GetPlanTargetListService } from '../api-services/get-plan-target-list.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

/**
 * 商品企画マスタ画面　選定候補一覧 モジュール設定クラス
 *
 * @export KYMW1300TargetListModule
 * @class KYMW1300TargetListModule
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjNavModule,
    FontAwesomeModule,
  ],
  declarations: [
    KYMW1300TargetListComponent,
  ],
  providers: [
    KYMW1300Model,
    GetPlanTargetListService,
  ],
  exports: [
    KYMW1300TargetListComponent,
  ]
})
export class KYMW1300TargetListModule {
}
